import { useTranslation } from 'react-i18next';
import { SetStateAction, useAtom, WritableAtom } from 'jotai';
import { useTagsAutocomplete } from 'tags/hooks/useTagsAutocomplete';
import { useDebounce } from 'common/useDebounce';
import { useState } from 'react';
import { Autocomplete } from 'common/components/Inputs/Autocomplete/Autocomplete';

type TagsSearchInputProps = {
  tagsFilterAtom: WritableAtom<string[], [SetStateAction<string[]>], void>;
  tagsHintsAtom: WritableAtom<any, [any], void>;
};

export const TagsSearchFilter = ({ tagsFilterAtom, tagsHintsAtom }: TagsSearchInputProps) => {
  const { t } = useTranslation();

  const [hints, removeHints] = useAtom(tagsHintsAtom);

  const [tagSearch, setTagSearch] = useState('');
  const debounceTagSearch = useDebounce(tagSearch, 500);

  const [tags, setTags] = useAtom(tagsFilterAtom);

  const {
    options: tagsOptions,
    isSelectedOptionFetching,
    isFetched,
    selectedOptions,
    hintOptions,
    updateSelectedOptions,
    hasNextPage,
    fetchNextPage,
  } = useTagsAutocomplete({
    search: debounceTagSearch,
    initialIds: tags,
    hints: hints,
    onSelectedChange: (options) => {
      setTags(options.map(({ id }) => String(id)));
    },
  });

  return (
    <Autocomplete
      data-testid="tags-multiselect"
      placeholder={t('rSimInventory.tagsFilterPlaceholder')}
      skeletonRepeats={tags.length}
      inputLoading={isSelectedOptionFetching}
      options={tagsOptions}
      value={selectedOptions}
      hints={hintOptions}
      onChange={updateSelectedOptions}
      onSearch={setTagSearch}
      loading={!isFetched}
      onHintRemove={removeHints}
      variant="outlined"
      hasMore={hasNextPage}
      onMoreShouldBeLoad={fetchNextPage}
    />
  );
};
